// @flow

/**
 *  @deprecated It will be removed in 6 months 09-15-2025. use `@pb/kit-component-native-scroll`
 *  */
export const Direction = {
    VERTICAL: 'VERTICAL',
    HORIZONTAL: 'HORIZONTAL'
};
/**
 *  @deprecated It will be removed in 6 months 09-15-2025. use `@pb/kit-component-native-scroll`
 *  */
export type DirectionType = $Keys<typeof Direction>;

/**
 *  @deprecated It will be removed in 6 months 09-15-2025. use `@pb/kit-component-native-scroll`
 *  */
export const Style = {
    LIGHT: 'LIGHT',
    DARK: 'DARK'
};
/**
 *  @deprecated It will be removed in 6 months 09-15-2025. use `@pb/kit-component-native-scroll`
 *  */
export type StyleType = $Keys<typeof Style>;

/**
 *  @deprecated It will be removed in 6 months 09-15-2025. use `@pb/kit-component-native-scroll`
 *  */
export const ArrowDirection = {
    LEFT: 'LEFT',
    RIGHT: 'RIGHT'
};
/**
 *  @deprecated It will be removed in 6 months 09-15-2025. use `@pb/kit-component-native-scroll`
 *  */
export type ArrowDirectionType = $Keys<typeof ArrowDirection>;


/**
 *  @deprecated It will be removed in 6 months 09-15-2025. use `@pb/kit-component-native-scroll`
 *  */
export const CANCEL_SCROLLABLE = 'scrollable_cancel-dragging';
/**
 *  @deprecated It will be removed in 6 months 09-15-2025. use `@pb/kit-component-native-scroll`
 *  */
export const DELTA = 50;

/**
 *  @deprecated It will be removed in 6 months 09-15-2025. use `@pb/kit-component-native-scroll`
 *  */
export const ARROW_SCROLLING_TIME = 300;

/**
 *  @deprecated It will be removed in 6 months 09-15-2025. use `@pb/kit-component-native-scroll`
 *  */
const verticalSettings = {
    delta: 'deltaY',
    pageAxis: 'clientY',
    lastAxis: 'lastY',
    axis: 'y',
    margin: 'marginTop',
    indent: 'top',
    size: 'height',
    step: 0.6,
    offsetSize: 'clientHeight'
};

/**
 *  @deprecated It will be removed in 6 months 09-15-2025. use `@pb/kit-component-native-scroll`
 *  */
const horizontalSettings = {
    delta: 'deltaX',
    pageAxis: 'clientX',
    lastAxis: 'lastX',
    axis: 'x',
    margin: 'marginLeft',
    indent: 'left',
    size: 'width',
    step: 1,
    offsetSize: 'clientWidth'
};

/**
 *  @deprecated It will be removed in 6 months 09-15-2025. use `@pb/kit-component-native-scroll`
 *  */
export const SETTINGS: { [key: DirectionType]: typeof verticalSettings & typeof horizontalSettings, } = {
    [Direction.VERTICAL]: verticalSettings,
    [Direction.HORIZONTAL]: horizontalSettings
};

/**
 *  @deprecated It will be removed in 6 months 09-15-2025. use `@pb/kit-component-native-scroll`
 *  */
export const CUSTOM_SCROLL_EVENT = 'customScroll';

/**
 *  @deprecated It will be removed in 6 months 09-15-2025. use `@pb/kit-component-native-scroll`
 *  */
export const ONWHELL_THROTTLE_TIME = 50;
